/**
 * main.js — Point d'entrée Bulle (Vite)
 * 
 * Tous les fichiers sont des IIFE (Immediately Invoked Function Expressions)
 * qui communiquent via window globals. Vite les bundle + minifie ensemble.
 * 
 * L'ORDRE D'IMPORT EST CRITIQUE — ne pas modifier sans raison.
 * Les CDN (Supabase, PixiJS) sont chargés en <script> dans index.html
 * AVANT ce module, donc window.supabase et window.PIXI sont disponibles.
 */

// 1. Cards data shim (must be before app.js)
import './cards.js';

// 2. Effects registry (DISABLED — app.js uses its own switch/case for E_* effects)
// import './effects.js';

// 2b. Services bootstrap (Supabase singleton + auth/deck services)
import './services.js';


// 3. Game core (main logic — creates most window globals)
import './app.js';

// 3b. Cloud deck import (Supabase Auth -> decklists -> paste into Setup)
import './cloudDeckImport.js';

// 4. UI fixes
import './topbarHardFix.js';

// 5. Premium system
import './premium-config.js';
import './AudioManager.js';
import './PreloadManager.js';
import './premium-enhancements.js';

// 6. Hand reorder (uses window.myHandPile, window.renderHandCards from app.js)
import './hand-reorder.js';

// 7. PixiJS board overlay (uses window.PIXI from CDN)
import './pixiBoard.js';
import './pixi-postfx.js';

// 8. Score track
import './scoreTrackDrag.js';


// 9. PWA Service Worker (update instant + optional popup)
(() => {
  if (!('serviceWorker' in navigator)) return;

  function showUpdateBanner(onUpdate) {
    // Avoid duplicates
    if (document.getElementById('pwaUpdateBanner')) return;

    const banner = document.createElement('div');
    banner.id = 'pwaUpdateBanner';
    banner.setAttribute('role', 'status');
    banner.style.position = 'fixed';
    banner.style.left = '12px';
    banner.style.right = '12px';
    banner.style.bottom = '12px';
    banner.style.zIndex = '999999';
    banner.style.display = 'flex';
    banner.style.gap = '10px';
    banner.style.alignItems = 'center';
    banner.style.justifyContent = 'space-between';
    banner.style.padding = '12px 14px';
    banner.style.borderRadius = '14px';
    banner.style.background = 'rgba(15,15,18,0.92)';
    banner.style.color = '#fff';
    banner.style.boxShadow = '0 10px 30px rgba(0,0,0,0.35)';
    banner.style.backdropFilter = 'blur(10px)';

    const left = document.createElement('div');
    left.style.display = 'flex';
    left.style.flexDirection = 'column';
    left.style.gap = '2px';

    const title = document.createElement('div');
    title.textContent = '✨ Nouvelle version disponible';
    title.style.fontWeight = '700';
    title.style.fontSize = '14px';

    const sub = document.createElement('div');
    sub.textContent = 'Clique pour mettre à jour maintenant.';
    sub.style.opacity = '0.85';
    sub.style.fontSize = '12px';

    left.appendChild(title);
    left.appendChild(sub);

    const right = document.createElement('div');
    right.style.display = 'flex';
    right.style.gap = '8px';
    right.style.alignItems = 'center';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = 'Mettre à jour';
    btn.style.border = '0';
    btn.style.cursor = 'pointer';
    btn.style.padding = '10px 12px';
    btn.style.borderRadius = '12px';
    btn.style.fontWeight = '700';
    btn.style.fontSize = '13px';
    btn.style.background = '#ffffff';
    btn.style.color = '#000000';

    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = '✕';
    close.style.border = '0';
    close.style.cursor = 'pointer';
    close.style.width = '36px';
    close.style.height = '36px';
    close.style.borderRadius = '12px';
    close.style.background = 'rgba(255,255,255,0.12)';
    close.style.color = '#fff';
    close.style.fontWeight = '800';

    btn.addEventListener('click', () => onUpdate());
    close.addEventListener('click', () => banner.remove());

    right.appendChild(btn);
    right.appendChild(close);

    banner.appendChild(left);
    banner.appendChild(right);
    document.body.appendChild(banner);
  }

  window.addEventListener('load', async () => {
    try {
      const reg = await navigator.serviceWorker.register('/sw.js');

      // If there's already a waiting SW, show banner right away.
      if (reg.waiting) {
        showUpdateBanner(() => {
          reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        });
      }

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          // When the new SW is installed and there's an existing controller,
          // it means an update is ready.
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            showUpdateBanner(() => {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            });
          }
        });
      });

      // When SW takes control, reload to get the latest assets.
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });
    } catch (e) {
      // Fail silently — the game must keep running even if SW registration fails.
      // console.warn('[PWA] SW register failed', e);
    }
  });
})();
